<div class="tutorization__message">
  <gl-textarea
    [(ngModel)]="message"
    [label]="'nouns.misTitle' | translate"
    [placeholder]="'actions.writeHere' | translate"
    [skeletorValueAccessor]="textarea"
  ></gl-textarea>
  <gl-button
    color-primary
    [disabled]="!message"
    [text]="'actions.send' | translate"
    (onClick)="sendMessage()"
  ></gl-button>
</div>

<div class="tools">
  <lms-items-count-selector class="hide-on-med-and-down" [listId]="listId"></lms-items-count-selector>
</div>
<lms-list
  [listId]="listId"
  [serviceProvider]="messagesService"
  (collectionUpdated)="setCollection($event)"
  [options]="listOptions"
>
  <div class="table-heading">
    <lms-list-header
      [listId]="listId"
      class="table-item"
      field="message"
      label="groupMessages.message"
    ></lms-list-header>
    <lms-list-header
      [listId]="listId"
      class="table-item"
      field="created_at"
      label="groupMessages.date"
    ></lms-list-header>
  </div>
  <ng-container *ngFor="let message of messages">
    <div class="table-row">
      <div class="table-item">{{ message.data.message }}</div>
      <div class="table-item">{{ message.created_at | lmsDate : group.timezone }}</div>
    </div>
  </ng-container>
</lms-list>
